import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import InfoSection from 'components/InfoSection'
import AppsIcon from 'components/icons/AppsIcon'
import withApps from 'models/apps'
import {APPLICATIONS} from 'utils/urls'

function SideInfoApps({apps}) {
  if (apps.length === 0) {
    return null
  }

  return (
    <InfoSection
      icon={<AppsIcon />}
      title={<Link to={APPLICATIONS}>Приложения</Link>}>
      Проверьте, у каких приложений и сайтов есть доступ к аккаунту
    </InfoSection>
  )
}

SideInfoApps.propTypes = {
  apps: PropTypes.array
}

export default withApps(SideInfoApps)
